<div class="mt-2 container">
  <div class="row" style="display: block;">
    <uni-stepper [showIndex]="false" [linear]="false" #stepper stepperId="consulta-solicitudes-fiduciaria-detalles">
      <uni-step label="Detalles Generales">
        <div class="case-data-comment" *ngIf="isWaitingForInformation">
          <b>En espera de información</b> 
          <p>{{ caseDataComment || "Sin comentarios" }}</p>
        </div>
        <div class="case-data-comment" *ngIf="isFinished">
          <b>Comentario de finalización</b>
          <p>{{ caseFinalResponseComment || "Sin comentarios" }}</p>
          <br/>
          <p>
            <b>Importante:</b> 
            {{caseCloseNote}}
          </p>
        </div>
        <uni-summary style="margin:0 auto;">
          <uni-summary-header color="gray" alignment="block">
            <uni-summary-section name="No. Solicitud" [description]="request.requestNumber"></uni-summary-section>
            <uni-summary-section name="RNC" [description]="request.rnc"></uni-summary-section>
            <uni-summary-section name="Fideicomiso" [description]="request.trusteeship"></uni-summary-section>
          </uni-summary-header>
          <uni-summary-group alignment="block">
            <uni-summary-section name="Etapa" [description]="request.stage"></uni-summary-section>
            <uni-summary-section name="Cantidad de Facturas" [description]="request.quantityInvoices"></uni-summary-section>
            <uni-summary-section name="Moneda" [description]="request.currencyType"></uni-summary-section>
            <uni-summary-section name="Monto" [description]="request.amount | number: '1.2-2'"></uni-summary-section>
            <uni-summary-section name="Tipo de Identificación" [description]="request.identificationType"></uni-summary-section>
            <uni-summary-section name="Número de Identificación" [description]="request.identificationNumber"></uni-summary-section>
            <uni-summary-section name="Nombre del Cliente" [description]="request.customerName"></uni-summary-section>
            <uni-summary-section name="Estatus" [description]="request.status"></uni-summary-section>
            <uni-summary-section name="Descripción del caso" [description]="request.subject"></uni-summary-section>
          </uni-summary-group>
        </uni-summary>
      </uni-step>

      <uni-step label="Documentos" (click)="changeStep(1)" (keyUp)="onKeyUpChangeStep($event)">
        <div class="case-data-comment" *ngIf="isWaitingForInformation">
          <b>En espera de información</b> 
          <p>{{ caseDataComment || "Sin comentarios" }}</p>
        </div>
        <div class="case-data-comment" *ngIf="isFinished">
          <b>Comentario de finalización</b> 
          <p>{{ caseFinalResponseComment || "Sin comentarios" }}</p>
          <br/>
          <p>
            <b>Importante:</b> 
            {{caseCloseNote}}
          </p>
        </div>
        <app-request-details-documents 
        [formatDate]="formatDate"
        [formatDateTime]="formatDateTime"
        [estadoEsperaInformacionCliente]="estadoEsperaInformacionCliente"
        [request]="request" 
        [observationMessage]="caseDataComment"
        [createdByFiduciary]="createdByFiduciary"
        [fiduciaryNote]="fiduciaryNote"
        (refreshRequestResult)="getRequestResult()"
        style="width:100%;"></app-request-details-documents>
      </uni-step>

      <uni-step label="Comentarios" (click)="changeStep(2)" (keyUp)="onKeyUpChangeStep($event)">
        <div class="case-data-comment" *ngIf="isWaitingForInformation">
          <b>En espera de información</b> 
          <p>{{ caseDataComment || "Sin comentarios" }}</p>
        </div>
        <div class="case-data-comment" *ngIf="isFinished">
          <b>Comentario de finalización</b> 
          <p>{{ caseFinalResponseComment || "Sin comentarios" }}</p>
          <br/>
          <p>
            <b>Importante:</b> 
            {{caseCloseNote}}
          </p>
        </div>
        <app-request-details-comments 
        [formatDate]="formatDate"
        [formatDateTime]="formatDateTime"
        [request]="request" 
        style="width:100%;"></app-request-details-comments>
      </uni-step>
    </uni-stepper>
  </div>
</div>



